import { z } from 'zod'

export const schema = z.object({
  userId: z.string(),
  userType: z.enum(['TRAVELER', 'OWNER', 'EMPLOYEE']),
  erck: z.string(),
  sfRemember: z.string().optional().nullable(),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  emailAddress: z.string(),
  password: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
